/**
 * Activity bonus (reference: the operator's "Bonus & Reytinq" page): activity points for what a player does during
 * the day, a daily top with prizes for the first places, and rewards for active play time.
 */
export const ACTIVITY_POINTS = {
  message: 10,
  song: 5,
  booster: 3,
  gift: 2,
  round: 1,
  sticker: 1,
  wheel: 1,
} as const;

export type ActivityKind = keyof typeof ACTIVITY_POINTS;

export const ACTIVITY = {
  /** Chat messages that earn points per day (more are allowed, they just stop counting). */
  messageCap: 50,
  /** Time between two actions counts as play time up to this long. */
  gapMinutes: 10,
  /** Places shown in the daily top. */
  topSize: 20,
} as const;
